export default "__VITE_ASSET__Cg5eSZC9__"